// src/assets/images/index.js
import Logo from "./logo.png";
import LogoLight from "./logo-light.png";
import Card_bg from "./card_bg.png";
import ScrollNext from "./scrollNext.gif";

export { Logo, LogoLight, Card_bg, ScrollNext };
